import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Trash2, Plus } from "lucide-react";
import type { ClientSigner } from "./types";

/**
 * List of client signers (name + e-mail, add/remove) — shared between the
 * pdf_upload field editor (so the operator can label real signers, not just
 * "the lead") and the send-signature dialogs (so the final list matches).
 */
export function ClientSignersEditor({
  value,
  onChange,
  minCount = 1,
}: {
  value: ClientSigner[];
  onChange: (next: ClientSigner[]) => void;
  minCount?: number;
}) {
  const update = (i: number, k: keyof ClientSigner, v: string) => {
    onChange(value.map((s, idx) => (idx === i ? { ...s, [k]: v } : s)));
  };

  return (
    <div className="space-y-2">
      <span id="signers-label" className="text-sm font-medium leading-none">
        Signatários
      </span>
      {value.map((s, i) => (
        <div key={i} className="flex gap-2">
          <Input
            placeholder="Nome completo"
            value={s.name}
            onChange={(e) => update(i, "name", e.target.value)}
          />
          <Input
            placeholder="email@exemplo.com"
            type="email"
            value={s.email}
            onChange={(e) => update(i, "email", e.target.value)}
          />
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onChange(value.filter((_, idx) => idx !== i))}
            disabled={value.length <= minCount}
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      ))}
      <Button
        variant="outline"
        size="sm"
        onClick={() => onChange([...value, { name: "", email: "" }])}
      >
        <Plus className="mr-2 h-4 w-4" /> Adicionar signatário
      </Button>
    </div>
  );
}
